const analyticsEvent = (category, action, label, dimensions = []) => {
    const dataLayer = window.dataLayer = window.dataLayer || [];
    
    const data = {
        event: 'eventTracking',
        category: category,
        action: action,
        label: label
    };

    if (typeof dimensions === 'string') {
        data.dimension1 = dimensions;
    } else if (typeof dimensions === 'object') {
        dimensions.forEach((dimension, index) => {
            if (typeof dimension === 'string') {
                const id = index + 1;
                data['dimension' + id] = dimension;
            }
        });
    }

    dataLayer.push(data);
};

export default analyticsEvent;


// WEBPACK FOOTER //
// ./js/analyticsEvent.js